import styled from 'styled-components'
import Section, { Panel, SectionPanels } from './Section'
import FlexibilityIcon from '@icons/Flexibility'
import EarningsIcon from '@icons/Earnings'
import SupportIcon from '@icons/Support'
import { t, tStr } from '@utils/lang'

const InfoSection = styled(Section)`
  background: var(--themeColorBetaBgBrown);
  ul li {
    color: var(--themeColorBetaSecondary);
  }
`

const WhyDeliver = () => (
  <InfoSection title={tStr('whyTitle_s')} tagLine={tStr('whyTagLine_s')}>
    <SectionPanels>
      <Panel title={tStr('whyFlexibilityTitle_s')} img={<FlexibilityIcon />}>
        {t('whyFlexibilityBody_s')}
      </Panel>
      <Panel title={tStr('whyEarningsTitle_s')} img={<EarningsIcon />}>
        {t('whyEarningsBody_s')}
      </Panel>
      <Panel title={tStr('whySupportTitle_s')} img={<SupportIcon />}>
        {t('whySupportBody_s')}
      </Panel>
    </SectionPanels>
  </InfoSection>
)

export default WhyDeliver
